import { ProjectBillingModelDTO } from '../types/dto/project-billing-model.dto';
import { ProjectBillingModel } from '../types/project';

/**
 * Maps project billing model DTO to application enum.
 */
export const mapProjectBillingModelFromDTO = (dto: ProjectBillingModelDTO): ProjectBillingModel => {
  switch (dto) {
    case ProjectBillingModelDTO.FIXED_PRICE:
      return ProjectBillingModel.FixedPrice;
    case ProjectBillingModelDTO.TIME_AND_MATERIALS:
      return ProjectBillingModel.TM;
    case ProjectBillingModelDTO.NON_BILLABLE:
      return ProjectBillingModel.NonBillable;
    default:
      return ProjectBillingModel.TM; // Fallback
  }
};

/**
 * Maps application enum to project billing model DTO.
 */
export const mapProjectBillingModelToDTO = (model: ProjectBillingModel): ProjectBillingModelDTO => {
  switch (model) {
    case ProjectBillingModel.FixedPrice:
      return ProjectBillingModelDTO.FIXED_PRICE;
    case ProjectBillingModel.TM:
      return ProjectBillingModelDTO.TIME_AND_MATERIALS;
    case ProjectBillingModel.NonBillable:
      return ProjectBillingModelDTO.NON_BILLABLE;
    default:
      return ProjectBillingModelDTO.TIME_AND_MATERIALS; // Fallback
  }
};
